// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Пленарні засідання» (Plenary sessions, ключ `plenary`, група `legislation`). */
export const plenarySessionsManifest: IModuleManifest = {
  key: 'plenary',
  group: 'legislation',
  slug: 'plenary-sessions',
  prefix: 'PLN',
  name: { en: 'Plenary sessions', uk: 'Пленарні засідання' },
  entities: [
    { key: 'plenary', slug: 'plenary', name: { en: 'Plenary sessions', uk: 'Пленарні засідання' }, main: true },
    { key: 'vote', slug: 'vote', name: { en: 'Votes', uk: 'Голосування' }, main: false },
    { key: 'session_agenda_item', slug: 'session-agenda-item', name: { en: 'Session Agenda Items', uk: 'Пункти порядку денного' }, main: false },
    { key: 'session_speaker', slug: 'session-speaker', name: { en: 'Session Speakers', uk: 'Промовці' }, main: false },
    { key: 'session_vote_result', slug: 'session-vote-result', name: { en: 'Session Vote Results', uk: 'Результати голосувань' }, main: false },
    { key: 'session_attendance', slug: 'session-attendance', name: { en: 'Session Attendances', uk: 'Присутність' }, main: false },
    { key: 'session_status', slug: 'session-status', name: { en: 'Session Statuses', uk: 'Статуси' }, main: false },
    { key: 'vote_ballot', slug: 'vote-ballot', name: { en: 'Ballots', uk: 'Бюлетені' }, main: false },
  ],
  loadState: () => import('./state/plenarySessionsSlice').then((m) => m.plenarySessionsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
